import React from 'react';
import EventItem from '@/pages/Dashboard.page/EventItem/EventItem';
import { DateEvents } from '@/pages/Dashboard.page/types';
import { EventDate } from './Events.date';
import { LoadingOverlay, ScrollArea, Stack } from '@mantine/core';
import { getEventBorderColor } from '../helpers';
import { useMantineTheme } from '@mantine/core';

export const EventsList: React.FC<{
  eventsByDate: DateEvents[];
  selectedDay: string;
  scrolledIntoSelectDay: boolean;
  setScrolledIntoSelectDay: (value: boolean) => void;
  isRefetching: boolean;
}> = ({
  eventsByDate,
  selectedDay,
  scrolledIntoSelectDay,
  setScrolledIntoSelectDay,
  isRefetching,
}) => {
  const theme = useMantineTheme();

  return (
    <ScrollArea h={'100%'} type="auto" offsetScrollbars pos="relative">
      <LoadingOverlay visible={isRefetching} opacity={0.5} />
      {eventsByDate.map(({ events, date }, index) => (
        <Stack key={date} pr="md" mb="xl" gap="xs">
          <EventDate
            eventDate={date}
            isSelectedDay={date === selectedDay}
            scrolledIntoSelectDay={scrolledIntoSelectDay}
            setScrolledIntoSelectDay={setScrolledIntoSelectDay}
            isFirstElement={index === 0}
          />
          <Stack gap="xs">
            {events.map((event) => (
              <EventItem
                key={event.id}
                event={event}
                calendarItem
                borderColor={getEventBorderColor(event.eventType, theme)}
              />
            ))}
          </Stack>
        </Stack>
      ))}
    </ScrollArea>
  );
};
